<template>
  <vl-form-grid>
    <vl-column width="6">
      <dl-form-field #default="{ hasErrors }" labelBefore :mod-required="modRequired" name="van" :field="fields.start">
        <vl-datepicker
          id="dp-start"
          ref="startDate"
          v-model="start"
          visual-format="d/m/Y"
          :min-date="minStartDate"
          :max-date="maxStartDate"
          :mod-error="hasErrors"
        />
      </dl-form-field>
    </vl-column>
    <vl-column width="6">
      <dl-form-field #default="{ hasErrors }" labelBefore :mod-required="modRequired" name="tot" :field="fields.end">
        <vl-datepicker
          id="dp-end"
          ref="endDate"
          v-model="end"
          visual-format="d/m/Y"
          :min-date="minEndDate"
          :max-date="maxEndDate"
          :mod-error="hasErrors"
        />
      </dl-form-field>
    </vl-column>
  </vl-form-grid>
</template>

<script lang="ts" src="./dl-period.ts"></script>

<style lang="scss" scoped src="./dl-period.scss"></style>
